import { CtrlType } from "@yuigoto/ctrl";

/**
 * Controles para formulário da mágica do Cookie.
 */
export const MagicaCookieControls = [
  {
    required: true,
    name: "email",
    label: "E-Mail",
    type: CtrlType.EMAIL,
    placeholder: "mail@mail.com",
    value: "",
    requiredMessage: "O e-mail é obrigatório, fofa!",
    emailMessage: "Coloca um e-mail válido aí, por favor, né?"
  }
];
